import {uniqBy} from 'lodash'

export const getfilteredData = (data, updatedCompanies, updatedTags) => {
  const searchString = (data.filterInt.services.searchString || '').toLowerCase()
  const selectedCidns = updatedCompanies
  const locationsArray = updatedTags.locations
  const serviceTypesArray = updatedTags.serviceTypes
  let limitedServices = data.originalServices
  if (data.filterInt.services.userType !== 'staff_user') {
    limitedServices = data.originalServices.filter((item) => selectedCidns.includes(item.accountId))
  }

  if (locationsArray.length > 0) {
    limitedServices = [
      ...limitedServices.filter(
        (item) =>
          locationsArray.some((ele) => item.country.toLowerCase().includes(ele.toLowerCase())) ===
          true,
      ),
    ]
  }

  if (serviceTypesArray.length > 0) {
    limitedServices = [
      ...limitedServices.filter(
        (item) =>
          serviceTypesArray.some((ele) =>
            item.serviceType.toLowerCase().includes(ele.toLowerCase()),
          ) === true,
      ),
    ]
  }
  if (searchString === '') {
    return limitedServices
  }

  const availableServices = limitedServices

  const searchAvailableServiceType = availableServices.filter(
    (e) => e.serviceType && e.serviceType.toLowerCase().includes(searchString),
  )

  const searchAvailableServiceID = availableServices.filter(
    (e) => e.serviceId && e.serviceId.toLowerCase().includes(searchString),
  )

  const searchAvailableAEnd = availableServices.filter(
    (e) => e.aEnd && e.aEnd.toLowerCase().includes(searchString),
  )

  const searchAvailableCompany = availableServices.filter(
    (e) => e.company && e.company.toLowerCase().includes(searchString),
  )

  const searchAvailableZEnd = availableServices.filter(
    (e) => e.zEnd && e.zEnd.toLowerCase().includes(searchString),
  )

  const searchAvailableUserReference = availableServices.filter(
    (e) => e.userReference && e.userReference.toLowerCase().includes(searchString),
  )

  const searchAvailableBandwidth = availableServices.filter(
    (e) => e.bandwidth && e.bandwidth.toLowerCase().includes(searchString),
  )

  const searchAvailableparentServiceId = availableServices.filter(
    (e) => e.parentServiceId && e.parentServiceId.toLowerCase().includes(searchString),
  )

  const searchAvailableBillProfileNumber = availableServices.filter(
    (e) => e.billProfileNumber && e.billProfileNumber.toLowerCase().includes(searchString),
  )

  const searchAvailableContractTerms = availableServices.filter(
    (e) => e.contractTerms && e.contractTerms.toLowerCase().includes(searchString),
  )

  const searchAvailableContractExpiry = availableServices.filter(
    (e) => e.contractExpiry && e.contractExpiry.toLowerCase().includes(searchString),
  )

  const services = uniqBy(
    [
      ...searchAvailableServiceType,
      ...searchAvailableServiceID,
      ...searchAvailableAEnd,
      ...searchAvailableZEnd,
      ...searchAvailableUserReference,
      ...searchAvailableBandwidth,
      ...searchAvailableparentServiceId,
      ...searchAvailableBillProfileNumber,
      ...searchAvailableContractTerms,
      ...searchAvailableContractExpiry,
      ...searchAvailableCompany,
    ],
    (v) => v.serviceId,
  )

  return services
}

export const getfilteredSites = (data, updatedCompanies) => {
  const selectedCidns = updatedCompanies
  return data.originalSites.filter((item) => selectedCidns.includes(item.accountId))
}
